import * as React from 'react';
import type { SVGProps } from 'react';

const SvgCloseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={8} height={8} fill="none" {...props}>
    <path
      fill="#222426"
      d="M.168.168a.571.571 0 0 1 .809 0L4 3.192 7.023.168a.572.572 0 0 1 .81.809L4.807 4l3.024 3.023a.572.572 0 0 1-.809.81L4 4.807.977 7.832a.572.572 0 0 1-.81-.809L3.193 4 .168.977a.571.571 0 0 1 0-.81Z"
    />
  </svg>
);
export default SvgCloseIcon;
